import { MESSAGES_API } from "@/utils/apiUrl"
import backend from "@/utils/backend"
import * as types from "./mutation_types"
import { passParams } from "@/utils"




export const getAll = ({ commit, state }) => {
    const filter = passParams(state.filter)
    const url = MESSAGES_API+filter
    commit(types.SET_SHOW_LOADING)
    backend({ url, data: null, method: "GET" }).then(({ data }) => {
        commit(types.SET_ITEMS, data?.data?.reverse() ?? data?.reverse())
        commit(types.SET_PAGINATION, { ...data, data: null })
        commit(types.SET_IS_SUCCESS)
        commit(types.SET_MESSAGE, data.message ?? "Super")
        commit(types.SET_CURRENT_ITEM, null)
    }).catch((err) => {
        commit(types.SET_IS_ERROR)
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_PAGINATION, null)
        commit(types.SET_MESSAGE, (err?.response?.message ?? err.message ?? err))
    }).finally(() => {
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_HIDE_LOADING)

    })
}
export const getNextHistory = ({ commit, state }) => {
    const nextLinkUrl = state.pagination?.next_page_url ?? null
    if (!nextLinkUrl) {
        return
    }
    const filter = passParams(state.filter,false)
    const url = nextLinkUrl + filter
    backend({ url, data: null, method: "GET" }).then(({ data }) => {
        let result = data?.data?.reverse() ?? data?.reverse();

        const resultFinal = [...result, ...state.items];

        commit(types.SET_ITEMS, resultFinal)
        commit(types.SET_PAGINATION, { ...data, data: null })
        commit(types.SET_IS_SUCCESS)
        commit(types.SET_MESSAGE, data.message ?? "Super")
        commit(types.SET_CURRENT_ITEM, null)
    }).catch((err) => {
        commit(types.SET_IS_ERROR)
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_PAGINATION, null)
        commit(types.SET_MESSAGE, (err?.response?.message ?? err.message ?? err))
    }).finally(() => {


    })
}

export const socketMessage = ({ state, commit }, data) => {

    commit(types.SET_ITEMS, [...state.items, data]);
}

export const resetData = ({ commit }) => {
    commit(types.RESET)
}



